export default __webpack_public_path__ + "static/media/saclux-factory.d52c3c26.jpeg";